import { QueryStatus } from '@tanstack/react-query'

export const deriveLoadingStateFromQueryStatus = (queryStatus: QueryStatus) => {
  switch (queryStatus) {
    case 'error':
      return 'failed'

    case 'pending':
      return 'pending'

    case 'success':
      return 'ready'

    default:
      return undefined
  }
}
